const CLOUDASTRA_STATS = [
  { num: '8+', lbl: 'Years of experience' },
  { num: '200+', lbl: 'Clients served' },
  { num: '88%', lbl: 'Client retention' },
  { num: '6+', lbl: 'Industries served' },
]

const SECUREFLOW_STATS = [
  { num: '5', lbl: 'Payment rails covered: UPI, IMPS, NEFT, RTGS, ISO 20022' },
  { num: '3', lbl: 'Verdict paths (pass, flag, block) before funds settle' },
  { num: '80+', lbl: 'Typology rules out of the box, per tenant' },
  { num: '99.95%', lbl: 'Uptime SLA' },
]

export default function TrustBand() {
  return (
    <section className="sf-trust-band" id="trust">
      <div className="sf-container">
        <div className="sf-trust-band-header sf-reveal" data-sf-reveal>
          <span className="sf-trust-band-eyebrow">From the team behind Cloudastra</span>
          <h2>The software partner India&rsquo;s enterprises <em>lean on.</em></h2>
          <p>
            Cloudastra Technologies ships digital, cloud and AI-led platforms for fintech and
            cybersecurity leaders. SecureFlow is one of the products that grew out of that practice.
          </p>
        </div>

        <div className="sf-trust-band-row">
          <div className="sf-trust-band-sub">Cloudastra by the numbers</div>
          <div className="sf-trust-band-grid">
            {CLOUDASTRA_STATS.map((s, i) => (
              <div
                key={s.lbl}
                className={`sf-trust-stat sf-reveal${i ? ` sf-reveal-d${i}` : ''}`}
                data-sf-reveal
              >
                <div className="sf-trust-stat-num">{s.num}</div>
                <div className="sf-trust-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="sf-trust-band-row">
          <div className="sf-trust-band-sub sf-green">SecureFlow by the numbers</div>
          <div className="sf-trust-band-grid">
            {SECUREFLOW_STATS.map((s, i) => (
              <div
                key={s.lbl}
                className={`sf-trust-stat sf-green sf-reveal${i ? ` sf-reveal-d${i}` : ''}`}
                data-sf-reveal
              >
                <div className="sf-trust-stat-num">{s.num}</div>
                <div className="sf-trust-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .sf-trust-band {
          background: var(--bg);
          padding: clamp(96px,11vw,140px) 0;
          position: relative;
        }
        .sf-trust-band-header {
          text-align: center; max-width: 780px;
          margin: 0 auto 56px; padding: 0 var(--gutter);
        }
        .sf-trust-band-eyebrow {
          display: inline-flex; align-items: center; gap: 10px;
          font-family: var(--mono); font-size: 14px;
          letter-spacing: 0.18em; text-transform: uppercase;
          color: var(--ca-700); background: var(--ca-50);
          border: 1px solid var(--ca-200);
          padding: 10px 20px; border-radius: 999px;
          font-weight: 700;
        }
        .sf-trust-band-header h2 {
          margin-top: 22px;
          font-size: clamp(2.5rem,5vw,4rem);
          font-weight: 600; letter-spacing: -0.025em;
          line-height: 1.08; color: var(--text);
          text-wrap: balance;
        }
        .sf-trust-band-header h2 :global(em) {
          font-style: normal; font-weight: 500;
          background: linear-gradient(120deg,var(--ca-600) 0%,var(--ca-cyan) 50%,var(--sf-600) 100%);
          -webkit-background-clip: text; background-clip: text; color: transparent;
        }
        .sf-trust-band-header p {
          margin: 18px auto 0; max-width: 62ch;
          font-size: clamp(1rem,1.18vw,1.13rem);
          line-height: 1.65; color: var(--text-2);
          text-wrap: pretty;
        }
        .sf-trust-band-row {
          max-width: 1180px; margin: 0 auto 36px;
          padding: 0 var(--gutter);
        }
        .sf-trust-band-row:last-child { margin-bottom: 0; }
        .sf-trust-band-sub {
          text-align: center; font-family: var(--mono);
          font-size: 13px; letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--ca-700); font-weight: 700;
          margin-bottom: 28px;
        }
        .sf-trust-band-sub.sf-green { color: var(--sf-700); }
        .sf-trust-band-grid {
          display: grid;
          grid-template-columns: repeat(4,1fr);
          gap: 20px;
        }
        @media (max-width:880px) {
          .sf-trust-band-grid { grid-template-columns: repeat(2,1fr); gap: 16px; }
        }
        @media (max-width:540px) {
          .sf-trust-band-grid { grid-template-columns: 1fr; }
        }
        .sf-trust-stat {
          background: var(--ca-50);
          border: 1px solid var(--ca-100);
          border-radius: 18px;
          padding: 36px 22px; text-align: center;
          transition: transform 0.3s var(--ease), box-shadow 0.3s var(--ease);
          position: relative;
        }
        .sf-trust-stat:hover {
          transform: translateY(-4px);
          box-shadow: 0 24px 60px -20px rgba(14,165,233,0.20);
        }
        .sf-trust-stat.sf-green {
          background: var(--sf-50);
          border-color: var(--sf-100);
        }
        .sf-trust-stat.sf-green:hover {
          box-shadow: 0 24px 60px -20px rgba(34,197,94,0.20);
        }
        .sf-trust-stat-num {
          font-size: clamp(2.3rem,4.2vw,3.3rem);
          font-weight: 700; letter-spacing: -0.03em;
          line-height: 1; color: var(--ca-600);
          white-space: nowrap;
          font-variant-numeric: tabular-nums;
          min-height: 1em;
        }
        .sf-trust-stat.sf-green .sf-trust-stat-num { color: var(--sf-700); }
        .sf-trust-stat-lbl {
          margin-top: 14px; font-size: 14px;
          color: var(--text-2); line-height: 1.4;
        }
      `}</style>
    </section>
  )
}
